import { useState } from 'react';

/**
 * Champ mot de passe avec bouton 👁️ afficher/masquer — partagé par tous les écrans
 * d'auth (connexion gérant, réinitialisation, connexion super admin, inscription).
 */
export default function PasswordInput({
  value,
  onChange,
  autoComplete,
  placeholder,
  wrapperClassName,
}: {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  placeholder?: string;
  /** Classe du conteneur (marge/espacement). Défaut : marge haute légère. */
  wrapperClassName?: string;
}) {
  const [show, setShow] = useState(false);
  return (
    <div className={'relative ' + (wrapperClassName ?? 'mt-1')}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className="w-full rounded-lg border border-slate-300 px-3 py-2 pr-12"
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        title={show ? 'Masquer' : 'Afficher'}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded px-1.5 py-0.5 text-lg leading-none text-slate-400 hover:text-slate-700"
      >
        {show ? '🙈' : '👁️'}
      </button>
    </div>
  );
}
